import moment from 'moment';
import { Link } from 'react-router-dom';
import { PencilIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';

export default function SingleCustomCollectionTableRow({
  item,
  collectionId,
  displayFields,
  isSelected,
  onSelectItem,
}) {
  const { t } = useTranslation();
  // Format field value for display
  const formatFieldValue = (field, value) => {

    const toEditorPreview = (content) => {
      const rawText = typeof content === 'string' ? content.replace(/<[^>]+>/g, ' ').replace(/&nbsp;/g, ' ') : String(content || '')
      const normalized = rawText.replace(/\s+/g, ' ').trim()
      if (!normalized) return '-'
      const words = normalized.split(' ')
      return words.length > 8 ? `${words.slice(0, 8).join(' ')}...` : normalized
    }

    const getCellLink = () => {
      let parentCollectionName = field.lookupCollectionName;
      let itemLink = null;

      if (parentCollectionName === "Customers") 
        itemLink = `/system/customers/details/${value.fieldValue}`;
      else 
        itemLink = `/single-custom-collection/${field.lookupCollectionId}/details/${value.fieldValue}`;

      return <Link to={itemLink} className="text-blue-600 hover:underline">{value.fieldName || value.fieldValue}</Link>;
    };

    if (value === null || value === undefined || value === '') {
      return '-';
    }

    switch (field?.type) {
      case 'date':
        return moment(value).format('YYYY-MM-DD');
      case 'integer':
        return typeof value === 'number' ? value.toLocaleString() : value;
      case 'lookup':
        if(value?.fieldValue){
          return getCellLink();
        } else {
          return '-';
        }
      case 'editor':
        return toEditorPreview(value);
      default:
        return typeof value === 'string' && value.length > 50
          ? `${value.substring(0, 50)}...`
          : value;
    }
  };

  return (
    <tr className="hover:bg-gray-100">
      <td className="py-2 px-4 border-b border-gray-300 text-center">
        <input
          type="checkbox"
          checked={isSelected}
          onChange={(e) => onSelectItem(item._id, e.target.checked)}
          className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-2"
        />
      </td>

      {/* Dynamic field values */}
      {displayFields.map((field, index) => {
        const value = formatFieldValue(field, item[field.name]);
        let cellContent =
          index === 0 ? (
            <Link to={`/single-custom-collection/${collectionId}/details/${item._id}`} className="text-blue-600 hover:underline">{value}</Link>
          ) : (
            value
          );

        return (
          <td key={field.name} className="py-2 px-4 border-b border-gray-300 whitespace-nowrap">
            <div className="flex items-center">{cellContent}</div>
          </td>
        );
      })}

      {/* Created date */}
      <td className="py-2 px-4 border-b border-gray-300 whitespace-nowrap">
        <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
          {item.created ? moment(item.created).format('YYYY-MM-DD') : '-'}
        </span>
      </td>

      <td className="py-2 px-4 border-b border-gray-300 whitespace-nowrap text-right">
        <Link
          to={`/single-custom-collection/${collectionId}/edit/${item._id}`}
          className="inline-flex items-center gap-1 rounded-md border border-blue-100 bg-blue-50 px-3 py-1.5 text-sm font-medium text-blue-700 hover:bg-blue-100 focus:outline-none focus:ring-2 focus:ring-blue-200"
        >
          <PencilIcon className="h-4 w-4" />
          <span>{t('singleCustomCollection.list.actions.edit')}</span>
        </Link>
      </td>
    </tr>
  );
}
